export default "__VITE_ASSET__CUyYyV2l__"